import { render, staticRenderFns } from "./RenameList.vue?vue&type=template&id=20dc5394&scoped=true&"
import script from "./RenameList.vue?vue&type=script&lang=js&"
export * from "./RenameList.vue?vue&type=script&lang=js&"
import style0 from "./RenameList.vue?vue&type=style&index=0&id=20dc5394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc5394",
  null
  
)

export default component.exports